import type { Settings } from '@hotjar/webapp/domains/common/settings';
import { fetchSettings } from '@hotjar/webapp/domains/common/settings/api';
import { logError } from '@hotjar/webapp/lib/logger';

/**
 * A large amount of the app is still dependent on having access to the settings
 * being loaded onto the window object.
 * @deprecated import it from '@hotjar/settings' instead
 */
export function loadWindowSettings(): Promise<Settings | Error> {
  return fetchSettings()
    .then((settings) => {
      window.settings = settings;

      return window.settings;
    })
    .catch(() => {
      const error = new Error('Failed to load /api/v1/settings');

      logError(error);
      throw error;
    });
}
